import { ID, SingleApiResponse } from '@ianesthesie-kit/services';
import { AnesthesiaInfo, AnesthesiaRisk } from './anesthesiaInfo.model';
import { PatchableMedicalService } from '../patchableMedical.service';
import { MedicalOptionGroupCode } from '@/modules/surgicalEvent';
import { MedicalResponse } from '@/modules/surgicalEvent/baseMedical.service';
import axios, { AxiosResponse } from 'axios';

export class AnesthesiaInfoService extends PatchableMedicalService<AnesthesiaInfo> {
  private static INSTANCE_BY_ID: AnesthesiaInfoService;

  private constructor(patientId: string) {
    super('/anesthesia', patientId);
  }

  private get riskUrl() {
    return `${this.url}/risk`;
  }

  public static getInstance(patientId: ID): AnesthesiaInfoService {
    if (this.shouldCreateNewInstance(this.INSTANCE_BY_ID, patientId)) {
      this.INSTANCE_BY_ID = new AnesthesiaInfoService(patientId);
    }

    return this.INSTANCE_BY_ID;
  }

  patchRisks(
    partial: Partial<AnesthesiaRisk>
  ): Promise<MedicalResponse<AnesthesiaRisk, false>> {
    return axios
      .patch(this.riskUrl, partial)
      .then(
        (response: AxiosResponse<SingleApiResponse<AnesthesiaRisk>>) =>
          response.data
      )
      .then((responseData) => ({
        data: this.transformResponseEntity(responseData.data)
      }))
      .catch((err) => {
        throw this.unwrapErrorDetails(err) || err;
      });
  }

  fetchRisks(): Promise<MedicalResponse<AnesthesiaRisk, false>> {
    return axios
      .get(this.riskUrl)
      .then((response: AxiosResponse<SingleApiResponse<AnesthesiaRisk>>) => ({
        data: this.transformResponseEntity(response.data.data)
      }))
      .catch((err) => {
        throw this.unwrapErrorDetails(err) || err;
      });
  }

  getFieldOptionGroupMapping(): {
    [k in keyof AnesthesiaInfo]?: MedicalOptionGroupCode;
  } {
    return {
      gaAirwayType: MedicalOptionGroupCode.GA_AIRWAY_TYPE,
      ponvPrevention: MedicalOptionGroupCode.PONV_PREVENTION,
      preopVentilation: MedicalOptionGroupCode.PONV_PREVENTION
    };
  }
}
